import { createFileRoute } from "@tanstack/react-router";
import { useSearch } from "@tanstack/react-router";
import type { ClientLocationBaseData } from "api-types/locations/locationsResponses";
import BuilderPortalLayout from "lib/components/builders/BuilderPortalLayout";
import { EditLocation } from "lib/components/builders/communities/EditLocation";
import { FetchErrorMessage } from "lib/components/errors/FetchErrorMessage";
import { getBuilderLocationBaseDataURL } from "lib/endpointHelpers";
import { useFetch } from "lib/fetcher";
import { LOCATION_REDIRECT_PARAM, locationHomePlansPath, useAppRouterParams } from "lib/routeHelpers";
import Loading from "ui/components/Loading";
import withAuthentication from "../../../../../components/withAuthentication";

function NewLocationPage() {
  const { builderId, locationId } = useAppRouterParams();

  const { data, loading, error } = useFetch<ClientLocationBaseData>(
    builderId && locationId ? getBuilderLocationBaseDataURL({ builderId, locationId }) : "",
    [builderId, locationId],
    { handleErrorLocally: true },
  );

  const searchParams = useSearch({ strict: false });
  const { [LOCATION_REDIRECT_PARAM]: redirectTo } = searchParams as Record<string, string | undefined>;

  const ready = builderId && locationId && !loading && !error && data;

  return (
    <BuilderPortalLayout selected="locations" pageTitle={`Edit ${data?.location?.name ?? ""}`}>
      {!ready && loading && <Loading />}
      {!ready && error && <FetchErrorMessage fetchError={error} />}
      {ready && (
        <EditLocation
          key={data.location.id}
          builderId={builderId}
          redirectTo={typeof redirectTo === "string" ? redirectTo : locationHomePlansPath(builderId, locationId)}
          location={data.location}
        />
      )}
    </BuilderPortalLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/edit")({
  component: withAuthentication(NewLocationPage, {
    permissions: ["EDIT_COMMUNITIES"],
    resource: {
      resourceType: "communities",
      routeParamName: "location_id",
    },
  }),
});
